/* eslint-disable no-console */
import { Injectable } from '@angular/core';
import { ErrorCodes } from '@shared';
import { LoggingService } from '@shared/logging';
import { IJSONFileExporter } from './json-file-exporter.interface';
import { ExportJSONFileModel } from './models/export-file.model';

@Injectable()
export class WebFileExporter implements IJSONFileExporter {
	public constructor(private loggerService: LoggingService) {}

	public async exportFile(file: ExportJSONFileModel) {
		try {
			const dlink: HTMLAnchorElement = document.createElement('a');
			dlink.download = file.FileName + '.json'; // the file name
			delete file.FileName;
			const jsonFileContent: string = JSON.stringify(file);

			const blobContent = new Blob([jsonFileContent], {
				type: 'text/plain;charset=utf-8,\uFEFF'
			});
			const url = URL.createObjectURL(blobContent);
			dlink.href = url;
			dlink.click();
			dlink.remove();
		} catch (error) {
			this.loggerService.error(ErrorCodes.WebExportError, error);
			throw error;
		}
	}
}
